// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class WarehouseResource extends Resource {
    basePath: string = 'warehouse/warehouses/';

    objectPath: string = 'warehouse/warehouses/{ident}/';

    // This method uses a restricted API endpoint that returns all warehouses
    // but with very limited data, should be used only for dropdowns and such
    listAllWarehouses(): Promise<Object> {
        return this.client._request(
            'warehouse/operation-warehouses/',
            'GET',
        ).then((response) => response.data);
    }
}
